<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-03-25 14:57:58
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 17:29:04
 * @FilePath: /privacy-web/src/components/homePage/PrivacyProtectConceptContent.vue
-->
<template>
  <div
    class="PrivacyProtectConceptContent-main"
    :class="{ 'PrivacyProtectConceptContent-main-mobile': isMobile }"
  >
    <div class="headers">贝壳隐私，从心触发，全心守护</div>
    <PrivacyProtectConceptContentItem :src="src"></PrivacyProtectConceptContentItem>
  </div>
</template>
<script>
export default {
  // 隐私保护理念内容
  name: "PrivacyProtectConceptContent",
  props: {
    src: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // contentList: [
      //   {
      //     title: '四大原则',
      //     content:
      //       '自上而下的组织与保护体系 公开透明的隐私保护制度 安全可靠的信息安全技术 合理必要的收集客户信息',
      //     bgImage: require('@/assets/images/homePage/four-principles.png'),
      //     key: 'four'
      //   },
      //   {
      //     title: '三大承诺',
      //     content: '您的信息 由您掌控 您的数据 为您加密 您的隐私 仅您可见',
      //     bgImage: require('@/assets/images/homePage/three-commitments.png'),
      //     key: 'three',
      //     className: 'custom-class'
      //   }
      // ]
    };
  },
};
</script>
<style lang="scss" scoped>
.PrivacyProtectConceptContent-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .headers {
    font-size: calc($multiple * 16px);
    font-family: PingFangTC-Regular, PingFangTC;
    font-weight: 400;
    color: #8b8b8b;
    line-height: calc($multiple * 36px);
    letter-spacing: 1px;
    margin-top: calc($multiple * 21px);
  }
}
.PrivacyProtectConceptContent-main-mobile {
  .headers {
    margin-top: 0.61rem;
    font-size: 0.72rem;
    font-family: PingFangTC-Regular, PingFangTC;
    font-weight: 400;
    color: #8b8b8b;
    line-height: 1.02rem;
  }
}
</style>
